import styled from "@emotion/styled";
import { formInputTheme } from "./formInputTheme";
// not using sizing constant due to the 2px border (would be 12/sizes.small)
export const StyledContentBeforeContainer = styled("div")`
    padding-left: ${getPadding};
    display: flex;
`;
function getPadding(_ref) {
  let {
    themeMode,
    validationState,
    isFocused,
    focusMode,
    variant
  } = _ref;
  if (variant === "underline") {
    return `${formInputTheme.padding.left.rest(themeMode)}px`;
  } else if (validationState === "error") {
    return `${formInputTheme.padding.left.error(themeMode)}px`;
  } else if (isFocused && focusMode !== "keyboard") {
    return `${formInputTheme.padding.left.active(themeMode)}px`;
  } else {
    return `${formInputTheme.padding.left.rest(themeMode)}px`;
  }
}
//# sourceMappingURL=StyledContentBeforeContainer.js.map